import {gql} from '@apollo/client';

export const CREATE_ORDER = gql`
    mutation createGetMoneyWwOrder ($data: GetMoneyWwOrderInput!, $token: String!, $currency: String!, $session: String) {
        createGetMoneyWwOrder(data: $data, token: $token, session: $session, currency: $currency) {
            data {
                id
                attributes {
                    payment {
                        data {
                            attributes {
                                orderUID
                                paymentURL
                            }
                        }
                    }
                }
            }
        }
    }
`